import IconButtonWithText from './iconButtonWithText';

export default IconButtonWithText;
